export default __webpack_public_path__ + "static/media/pexels-sheila-731217.d7e0aac2.png";